import React from "react";
import laserid from "../../../assets/icons/figma/laserid-card.svg";

export default function ExampleLaser() {
  return (
    <>
      <div className="sub-title-bold">
        เลขเลเซอร์หลังบัตรประชาชน
      </div>

      <div>
        การกรอกเลขเลเซอร์หลังบัตรประชาชน
      </div>
      <div>
        กรอกตัวอักษรและตัวเลขโดยไม่ต้องใส่ขีด เช่น JC0000000000
      </div>

      <img src={laserid} alt="" height={100}/>
    </>
  );
}